export class DocumentExportModel {
  constructor(
    public name?: string
  ) { }
}

